(function() {
  'use strict';

  angular
    .module('vzWidget', ['ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngResource', 'ui.router', 'ui.bootstrap', 'toastr', 'infinite-scroll', 'angular-carousel']);

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .service('authVz', authVz);

  /** @ngInject */
  function authVz(communication, VZ_API, $window){
    function _checkAuth(){
      communication.getUser();
    }

    function _authorize(){
      var win = $window.open(VZ_API.LOGIN, '_blank');
      win.focus();
    }

    var service = {
      check: _checkAuth,
      doAuth: _authorize
    };

    return service;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .service('storage', storage);

  /** @ngInject */
  function storage(site, $window){
    var TEMPLATE_KEY = 'VZ_WIDGET_PROCESS_TEMPLATE';
    var LAST_STORE_SOURCE_KEY = 'VZ_LAST_STORE_SOURCE_KEY';
    var MULTIPLE_IMAGES_MODE_KEY = 'VZ_MULTIPLE_IMAGES_MODE';

    function _setLastStoreSource(group, album){
      var obj = {
        group: group,
        album: album
      };
      $window.localStorage.setItem(LAST_STORE_SOURCE_KEY, $window.JSON.stringify(obj));
    }

    function _getLastStoreSource(){
      return $window.JSON.parse($window.localStorage.getItem(LAST_STORE_SOURCE_KEY)) || {};
    }

    function _setProcessTmpl(tmpl){
      var fromStore = $window.JSON.parse($window.localStorage.getItem(TEMPLATE_KEY)) || {};
      fromStore[site.getWidgetSiteHost()] = tmpl;
      $window.localStorage.setItem(TEMPLATE_KEY, $window.JSON.stringify(fromStore));
    }

    function _getProcessTmpl(){
      var fromStore = $window.JSON.parse($window.localStorage.getItem(TEMPLATE_KEY)) || {};
      return fromStore[site.getWidgetSiteHost()];
    }

    function _setMultipleImagesMode(val){
      var fromStore = $window.JSON.parse($window.localStorage.getItem(MULTIPLE_IMAGES_MODE_KEY)) || {};
      fromStore[site.getWidgetSiteHost()] = val;
      $window.localStorage.setItem(MULTIPLE_IMAGES_MODE_KEY, $window.JSON.stringify(fromStore));
    }

    function _getMultipleImagesMode(){
      var fromStore = $window.JSON.parse($window.localStorage.getItem(MULTIPLE_IMAGES_MODE_KEY)) || {};
      return fromStore[site.getWidgetSiteHost()];
    }

    var service = {
      setLastStoreSource: _setLastStoreSource,
      getLastStoreSource: _getLastStoreSource,
      setProcessTmpl: _setProcessTmpl,
      getProcessTmpl: _getProcessTmpl,
      setMultipleImagesMode: _setMultipleImagesMode,
      getMultipleImagesMode: _getMultipleImagesMode
    };

    return service;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .service('site', site);

  /** @ngInject */
  function site(){
    var widgetSiteUrl;
    var _afterSiteSetupCb;

    function _initAfterSetupCb(cb){
      _afterSiteSetupCb = cb;
    }

    function _onSiteSetup(){
      _afterSiteSetupCb && _afterSiteSetupCb();
    }

    function _setupWidgetSiteUrl(url){
      widgetSiteUrl = url;
      _onSiteSetup();
    }

    function _setupDevWidgetSiteUrl(){
      widgetSiteUrl = 'http://gepur.ru';
      _onSiteSetup();
    }

    function _getWidgetSiteUrl(){
      return widgetSiteUrl;
    }

    function _getWidgetSiteHost(){
      return (new URL(widgetSiteUrl)).host;
    }

    var service = {
      initAfterSetupCb: _initAfterSetupCb,
      setupWidgetSite: _setupWidgetSiteUrl,
      setupDevWidgetSiteUrl: _setupDevWidgetSiteUrl,
      getWidgetSiteUrl: _getWidgetSiteUrl,
      getWidgetSiteHost: _getWidgetSiteHost
    };

    return service;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .factory('messageSender', messageSender);

  /** @ngInject */
  function messageSender($window){
    var opener = $window.parent;
    var origin = '*';

    function _start(){
      if (opener){
        opener.postMessage({type: 'widget_init_finished'}, origin);
      }
    }

    function _userAuthorized(){
      opener.postMessage({type: 'widget_user_authorized'}, origin);
    }

    function _userUnauthorized(){
      opener.postMessage({type: 'widget_user_unauthorized'}, origin);
    }

    function _userIsProvider(expiration, statLink){
      opener.postMessage({type: 'widget_user_is_provider', expiration: expiration, statLink: statLink}, origin);
    }

    function _sizesUpdated(sizesData, statuses){
      opener.postMessage({type: 'widget_sizes_updated', sizes: sizesData, statuses: statuses}, origin);
    }

    function _productsCounterUpdated(counter){
      opener.postMessage({type: 'widget_products_counter_updated', counter: counter}, origin);
    }

    function _closeWidget(){
      opener.postMessage({type: 'widget_close'}, origin);
    }

    var factory = {
      productsCounterUpdated: _productsCounterUpdated,
      start: _start,
      userUnauthorized: _userUnauthorized,
      userAuthorized: _userAuthorized,
      userIsProvider: _userIsProvider,
      sizesUpdated: _sizesUpdated,
      closeWidget: _closeWidget
    };

    return factory;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .factory('messageListener', messageListener);

  /** @ngInject */
  function messageListener(communication, messageSender, site, STATES, $log, $rootScope, $state, $window){
    function _start(){
      $window.onmessage = function(e){
        var message = e.data;
        var messageType = message.type;
        if (window.vzWidgetLogsActive) $log.info('Catch message on widget: "' + messageType + '"' , message);

        switch (messageType){
          case 'widget_auth_completed':
            $rootScope.$emit(STATES.ON_AUTH_COMPLETE);
            break;

          case 'widget_catch_crawl':
            communication.crawl(message.url || e.origin, message.html, message.cookies, message.userAgent, message.clearBeforeCrawl);
            break;

          case 'widget_setup_site':
            site.setupWidgetSite(message.url);
            break;

          case 'widget_ask_products_counter':
            communication.askProductsCounterOnPage(message.url || e.origin, message.html);
            break;

          case 'widget_init_finished':
            //only for dev
            site.setupDevWidgetSiteUrl();
            break;

          case 'widget_reask_products':
            $rootScope.$emit(STATES.REASK_PRODUCTS);
            break;

          case 'widget_reask_issues':
            $rootScope.$emit(STATES.REASK_ISSUES);
            break;

          case 'to_login_page':
            $state.go('login')
            break;

          case 'to_upload_page':
            $state.go('root')
            break;

          case 'to_issues_page':
            $state.go('issues')
            break;

          case 'to_instruction_page':
            $state.go('instruction')
            break;
        }
      }
    }

    return {
      start: _start
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .service('issues', issues);

  /** @ngInject */
  function issues(VZ_API, messageSender, site, $timeout, $resource){
    var sizeCanceler;
    var issuesCanceler;
    var _API = $resource(VZ_API.WIDGET_ISSUES, {}, {
      clear: {
        method: 'DELETE'
      },
      cancel: {
        method: 'DELETE',
        url: VZ_API.ISSUES + '/:issueId'
      },
      sizes: {
        method: 'GET',
        url: VZ_API.WIDGET_SIZES
      }
    });

    var sizesPingInterval = 3000; //default value
    var issuesPingInterval = 10000; //default value

    var ISSUE_STATUSES = {
      NEW: 'new',
      PROCESS: 'process',
      DONE: 'done',
      ERROR: 'error',
      REJECTED: 'rejected'
    };

    var issues = {
      rs: null,
      $resolved: false
    };

    function _getStatuses(){
      return ISSUE_STATUSES;
    }

    function _setupPingInterval(sizesInterval, issuesInterval){
      sizesPingInterval = sizesInterval || sizesPingInterval;
      issuesPingInterval = issuesInterval || issuesPingInterval;
    }

    function _hasInProgress(issuesArray){
      var res = false;
      for (var i = 0; i < issuesArray.length; i++){
        if (issuesArray[i].status === ISSUE_STATUSES.PROCESS){
          res = true;
          break;
        }
      }

      return res;
    }

    function _get(){
      if (issuesCanceler) $timeout.cancel(issuesCanceler);
      var $q = _API.get({url: site.getWidgetSiteUrl()});
      issues.$resolved = false;

      $q.$promise.then(function(rs){
        issues.rs = rs.data;
        issues.$resolved = true;

        if (_hasInProgress(issues.rs)){
          issuesCanceler = $timeout(_get, issuesPingInterval);
        }
      });

      return issues;
    }

    function _cancelIssue(id){
      return _API.cancel({issueId: id});
    }

    function _getSizes(){
    if (sizeCanceler) $timeout.cancel(sizeCanceler);

      _API.sizes({url: site.getWidgetSiteUrl()}).$promise.then(function(rs){
        messageSender.sizesUpdated(rs, ISSUE_STATUSES);

        if (rs.crawling.status === ISSUE_STATUSES.PROCESS || rs.upload.status === ISSUE_STATUSES.PROCESS){
          sizeCanceler = $timeout(_getSizes, sizesPingInterval);
        }
      });
    }

    var service = {
      cancel: _cancelIssue,
      get: _get,
      getSizes: _getSizes,
      getStatuses: _getStatuses,
      setupPingInterval: _setupPingInterval
    };

    return service;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .service('communication', communication);

  /** @ngInject */
  function communication(site, issues, messageSender, jq, VZ_API, STATES, $http, $httpParamSerializer, $resource, $rootScope){
    var settings;
    var user = {
      rs: null,
      authorized: false
    }

    var _API = $resource(VZ_API.ROOT, {}, {
      settings: {
        url: VZ_API.SETTINGS,
        method: 'GET'
      },
      getUser: {
        url: VZ_API.WIDGET_USER,
        method: 'GET'
      },
      getSubscriptions : {
        url: VZ_API.SUBSCRIPTIONS,
        method: 'GET',
        isArray: true
      },
      groups: {
        url: VZ_API.USER_GROUPS,
        method: 'GET',
        isArray: true
      },
      crawl: {
        url: VZ_API.WIDGET_CRAWL,
        method: 'POST'
      },
      getProducts: {
        url: VZ_API.WIDGET_PRODUCTS,
        method: 'GET'
      },
      clearProducts: {
        url: VZ_API.WIDGET_PRODUCTS,
        method: 'DELETE'
      }
    });

    function _makeStatLink(providerId){
      return VZ_API.MAKE_STAT_LINK(providerId);
    }

    function _tryAth(){
      user.rs = _API.getUser();
      user.rs.$promise
        .then(function(){
          user.authorized = true;
          issues.getSizes();
          $rootScope.$emit(STATES.ON_AUTHORIZED);
          _getSubscriptions().$promise.then(function(rs){
            function _checkSite(elm){
              return elm.url === site.getWidgetSiteHost();
            }

            for (var i = 0; i < rs.length; i++){
              var item = rs[i];
              if (item.type === 'site' && item.sites.filter(_checkSite).length) $rootScope.$emit(STATES.ON_SUBSCRIPTIONS_RECEIVED, item.expire, _makeStatLink(item.provider.id));
            }
          });
        });
    }

    function _getUser(){
      return user;
    }

    function _getUserGroups(){
      var $q = _API.groups();
      $q.$promise.then(function(rs){
        rs.splice(0, 0, {
          id: 'personal',
          preview: user.rs.image,
          name: 'Личная страница',
          url: 'https://vk.com/id' + user.rs.uid
        });
      });
      return $q;
    }

    function _crawl(siteUrl, html, cookies, userAgent, clearBeforeCrawl){
      if (!user.authorized) return; //unathorized

      function _startCrawl(){
        var deffered = _API.crawl({}, {url: siteUrl, html: html, cookies: cookies, userAgent: userAgent});
        deffered.$promise.then(function(){
          issues.getSizes();
        });

        return deffered;
      }
      var $q = null;

      if (clearBeforeCrawl){
        $q = _clearProducts();
        $q.$promise.then(function(){
          _startCrawl();
        });
      } else {
        $q = _startCrawl();
      }

      return $q;
    }

    function _askProductsCounterOnPage(siteUrl, html){
      $http({
        method: 'POST',
        url: VZ_API.WIDGET_ASK_PRODUCTS_COUNTER,
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: $httpParamSerializer({url: siteUrl})
      }).success(function(rs){
        var arr = jq(jq.parseHTML(html)).find(rs);
        if (arr && arr.length) messageSender.productsCounterUpdated(arr.length);
      });
    }

    function _getProducts(){
      return _API.getProducts({url: site.getWidgetSiteUrl()});
    }

    function _clearProducts(){
      var $q = _API.clearProducts({url: site.getWidgetSiteUrl()});

      $q.$promise.then(function(){
        issues.getSizes();
      });

      return $q;
    }

    function _getSettings(){
      if (!settings){
        settings = _API.settings();
        settings.$promise.then(function(rs){
          issues.setupPingInterval(rs.ping.widget.sizes, rs.ping.widget.issues);
        });
      }
      return settings;
    }

    function _getSubscriptions(){
      return _API.getSubscriptions();
    }

    var cleanupEvent = $rootScope.$on(STATES.ON_AUTH_COMPLETE, function(){
      _tryAth();
    });

    $rootScope.$on('$destroy', function(){
      cleanupEvent();
    });

    _getSettings();
    site.initAfterSetupCb(function(){
      _tryAth();
    });

    var service = {
      askProductsCounterOnPage: _askProductsCounterOnPage,
      getUser: _getUser,
      getUserGroups: _getUserGroups,
      crawl: _crawl,
      getProducts: _getProducts,
      clearProducts: _clearProducts,
      getSettings: _getSettings
    };

    return service;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .service('album', album);

  /** @ngInject */
  function album(site, VZ_API, $resource){
    var currentAlbumParameters = {
      groupId: null,
      isPersonal: false,
      limit: 16,
      links: false
    }

    var albums = {
      data: [],
      size: 0,
      loading: false,
      hasMore: false
    };

    var _API = $resource(VZ_API.ALBUMS, {}, {
      create: {
        method: 'PUT'
      },
      store: {
        url: VZ_API.STORE_PRODUCTS,
        method: 'POST',
        params: {albumId: '@albumId'}
      },
      export: {
        url: VZ_API.WIDGET_EXPORT,
        method: 'POST'
      }
    });

    function _initAlbumParams(groupId, queryString){
      currentAlbumParameters.groupId = groupId;
      currentAlbumParameters.queryString = queryString;
      currentAlbumParameters.offset = 0;
      currentAlbumParameters.links = false;

      angular.extend(albums, {
        data: [],
        loading: true,
        hasMore: false,
        size: 0
      });

      if (!groupId){
        currentAlbumParameters.isPersonal = true;
      } else {
        currentAlbumParameters.isPersonal = false;
      }
    }

    function _fillAlbums(rs){
      albums.data.push.apply(albums.data, rs.data);
      albums.size = rs.size;
      albums.hasMore = rs.data.length === currentAlbumParameters.limit;
      albums.loading = false;
    }

    function _getUserAlbums(queryString){
      _initAlbumParams(null, queryString)
      _API.get(currentAlbumParameters).$promise.then(_fillAlbums);

      return albums;
    }

    function _getGroupAlbums(groupId, queryString){
      _initAlbumParams(groupId, queryString);
      _API.get(currentAlbumParameters).$promise.then(_fillAlbums);

      return albums;
    }

    function _getMoreAlbums(){
      currentAlbumParameters.offset = albums.data.length;
      albums.loading = true;
      _API.get(currentAlbumParameters).$promise.then(_fillAlbums);
    }

    function _createAlbum(opt){
      return _API.create({}, opt);
    }

    function _storeProducts(albumId, opt){
      opt.siteUrl = site.getWidgetSiteUrl();
      return _API.store({albumId: albumId}, opt);
    }

    function _exportToFile(products, tmpl){
      return _API.export({}, {
        siteUrl: site.getWidgetSiteUrl(),
        products: products,
        tmpl: tmpl
      });
    }

    var service = {
      getUserAlbums: _getUserAlbums,
      getGroupAlbums: _getGroupAlbums,
      getMoreAlbums: _getMoreAlbums,
      create: _createAlbum,
      storeProducts: _storeProducts,
      exportToFile: _exportToFile
    };

    return service;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('stateViewer', stateViewer());

  /** @ngInject */
  function stateViewer(){
    /** @ngInject */
    function stateViewerCtrl(album, communication, issues, messageSender, storage, STATES, $rootScope, $scope){
      var ctrl = this;

      function _getSiteProperties(site){
        site.currency = site.currency.toUpperCase();
        site.props = {};

        angular.forEach(site.properties, function(p){
          site.props[p.id] = p;
        });

        site.props.hasPrice = !!site.props.price;
        site.props.hasDescription = !!site.props.description;
        site.props.descriptionFields = site.props.hasDescription ? site.props.description.fields : [];
      }

      function _initTitleContent(newVal){
        if (newVal === 1){
          ctrl.titleContent = "Шаг 1: выберите товары для выкладки";
        } else if (newVal === 2){
          ctrl.titleContent = "Шаг 2: выберите группу и альбом";
        } else if (newVal === 4){
          ctrl.titleContent = "Экспорт выбранных продуктов в файл";
        } else {
          ctrl.titleContent = "";
        }
      }

      ctrl.selected = [];
      $scope.state = 1;

      ctrl.toNextState = function(){
        ++$scope.state;
      }

      ctrl.toFirstStep = function(){
        $scope.state = 1;
        ctrl.exportToFile = null;
      }

      ctrl.storeToAnotherSource = function(){
        $scope.state = 2;
        ctrl.storeProcess = null;
      }

      ctrl.afterProcess = function(){
        messageSender.closeWidget();
      }

      ctrl.cleanAndAfterProcess = function(){
        communication.clearProducts();
        ctrl.afterProcess();
      }

      ctrl.albumData = {
        tmpl: {}
      };

      ctrl.getProducts = function(){
        ctrl.selected = [];
        ctrl.products = communication.getProducts();
        ctrl.products.$promise.then(function(rs){
          _getSiteProperties(rs.site);
        });
      }

      ctrl.getProducts();

      var cleanupReaskEvent = $rootScope.$on(STATES.REASK_PRODUCTS, function(){
        $scope.state = 1;
        ctrl.getProducts();
        ctrl.storeProcess = null;
      });

      var cleanupProductsSelectedEvent = $rootScope.$on(STATES.PRODUCTS_SELECTED, function(){
        storage.setProcessTmpl(ctrl.albumData.tmpl);
        ctrl.toNextState();
      });

      var cleanupStoreEvent = $rootScope.$on(STATES.STORE_WITH_LAST_SOURCE, function(e, storeAlbum){
        ctrl.toNextState();
        ctrl.storeProcess = album.storeProducts(storeAlbum.id, {
          products: ctrl.selected,
          tmpl: ctrl.albumData.tmpl
        });

        ctrl.storeProcess.$promise.then(function(){
          issues.getSizes();
        });
      });

      var cleanupProductsExportEvent = $rootScope.$on(STATES.PRODUCTS_EXPORT_TO_FILE, function(){
        $scope.state = 4;
        ctrl.exportToFile = album.exportToFile(ctrl.selected, ctrl.albumData.tmpl);
      });

      $scope.$watch('state', _initTitleContent);

      $scope.$on('$destroy', function(){
        cleanupReaskEvent();
        cleanupProductsSelectedEvent();
        cleanupStoreEvent();
        cleanupProductsExportEvent();
      });
    }

    var component = {
      templateUrl: 'app/components/stateViewer/stateViewer.html',
      controller: stateViewerCtrl,
      bindings: {
        val: '='
      }
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('spinner', spinner());

  /** @ngInject */
  function spinner(){

    var component = {
      template: '<div class="spinner-wrapper text-center animated fadeInDown" ng-show="$ctrl.spinnerShow"><i class="fa fa-spin fa-spinner"></i></div>',
      bindings: {
        spinnerShow: '<'
      }
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('sourceSelector', sourceSelector());

  /** @ngInject */
  function sourceSelector(){
    /** @ngInject */
    function sourceSelectorCtrl(album, communication, storage, STATES, $rootScope, $scope){
      var ctrl = this;

      ctrl.groups = communication.getUserGroups();
      ctrl.currentGroup = {};
      ctrl.currentAlbum = {};

      function _getGroupId(group){
        return group.id !== 'personal' ? group.id : null;
      }

      ctrl.clickByGroup = function(group){
        if (ctrl.currentGroup.id === group.id) return;

        ctrl.query = null;
        ctrl.currentGroup.selected = false;
        group.selected = true;
        ctrl.currentGroup = group;
        ctrl.albums = album.getGroupAlbums(_getGroupId(group), null);
      }

      ctrl.clickByAlbum = function(album){
        if (ctrl.currentAlbum.id === album.id) return;

        ctrl.currentAlbum.selected = false;
        album.selected = true;
        ctrl.currentAlbum = album;
      }

      ctrl.refresh = function(){
        ctrl.query = null;
        ctrl.albums = album.getGroupAlbums(_getGroupId(ctrl.currentGroup), null);
      }

      ctrl.findAlbums = function(){
        ctrl.albums = album.getGroupAlbums(_getGroupId(ctrl.currentGroup), ctrl.query);
      }

      ctrl.scrollAlbums = function(){
        album.getMoreAlbums();
      }

      ctrl.processProducts = function(){
        storage.setLastStoreSource(ctrl.currentGroup, ctrl.currentAlbum);
        $rootScope.$emit(STATES.STORE_WITH_LAST_SOURCE, ctrl.currentAlbum);
      }

      $scope.$on('$destroy', function(){
        if (ctrl.currentGroup) ctrl.currentGroup.selected = false;
        if (ctrl.currentAlbum) ctrl.currentAlbum.selected = false;
      });
    }

    var component = {
      templateUrl: 'app/components/sourceSelector/sourceSelector.html',
      controller: sourceSelectorCtrl
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('productSelector', productSelector());

  /** @ngInject */
  function productSelector(){
    /** @ngInject */
    function productSelectorCtrl(){}

    var component = {
      templateUrl: 'app/components/productSelector/productSelector.html',
      controller: productSelectorCtrl,
      bindings: {
        products: '=',
        selectedProducts: '=',
        albumData: '='
      }
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('productList', productList());

  /** @ngInject */
  function productList(){
    /** @ngInject */
    function productListCtrl(communication, messageSender, storage, STATES, $rootScope){
      var ctrl = this;

      function selectItem(item){
        item.selected = true;
        ctrl.selectedProducts.push(item.id);
      }

      function unselectItem(item, idx){
        item.selected = false;
        if (~idx) ctrl.selectedProducts.splice(idx, 1);
      }

      function toggleSelected(item){
        var idx = ctrl.selectedProducts.indexOf(item.id);

        if (idx > -1){
          unselectItem(item, idx);
        } else {
          selectItem(item);
        }
      }

      ctrl.selectedAll = false;

      ctrl.clearProducts = function(){
          communication.clearProducts().$promise.then(function(){
              messageSender.closeWidget();
          });
      };

      ctrl.productsSelected = function(){
        $rootScope.$emit(STATES.PRODUCTS_SELECTED);
      };

      ctrl.selectAll = function(){
        ctrl.selectedAll = true;
        ctrl.selectedProducts.length = 0;
        angular.forEach(ctrl.products.data, function(item){
          if (!item.isVariant || ctrl.showMultipleImages && item.isVariant){
            selectItem(item)
          } else if (!ctrl.showMultipleImages && item.isVariant){
            unselectItem(item, -1);
          }
        });
      };

      ctrl.unselectAll = function(){
        ctrl.selectedAll = false;
        ctrl.selectedProducts.length = 0;
        angular.forEach(ctrl.products.data, function(item){
          unselectItem(item, ctrl.selectedProducts.indexOf(item.id));
        });
      };

      ctrl.clickByItem = function(item){
        ctrl.selectedAll = false;
        toggleSelected(item);
      };

      ctrl.exportToFile = function(){
        $rootScope.$emit(STATES.PRODUCTS_EXPORT_TO_FILE);
      };

      ctrl.storeToLastSource = function(){
        ctrl.productsSelected();
        $rootScope.$emit(STATES.STORE_WITH_LAST_SOURCE, ctrl.lastSource.album);
      };

      ctrl.toggleVariants = function(){
        ctrl.showMultipleImages = !ctrl.showMultipleImages;
        storage.setMultipleImagesMode(ctrl.showMultipleImages);
        ctrl.selectAll(true);
      };

      ctrl.showMode = function(){
        return function(item){
          return ctrl.showMultipleImages ? true : item.isVariant === false;
        };
      };

      ctrl.lastSource = storage.getLastStoreSource();
      ctrl.showMultipleImages = !!storage.getMultipleImagesMode();
      ctrl.selectAll();
    }

    var component = {
      templateUrl: 'app/components/productList/productList.html',
      controller: productListCtrl,
      bindings: {
        products: '=',
        selectedProducts: '=',
        site: '<',
        tmpl: '<'
      }
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('productItem', productItem());

  /** @ngInject */
  function productItem(){
    /** @ngInject */
    function productItemCtrl(PRICE){
      var ctrl = this;

      function _getToday(){
        var d = new Date();
        var year = d.getFullYear();
        var shortMonth = d.getMonth();
        var day = d.getUTCDate();
        var localizedMonth;

        switch (shortMonth){
          case 0:
            localizedMonth = 'января';
            break;
          case 1:
            localizedMonth = 'февраля';
            break;
          case 2:
            localizedMonth = 'марта';
            break;
          case 3:
            localizedMonth = 'апреля';
            break;
          case 4:
            localizedMonth = 'мая';
            break;
          case 5:
            localizedMonth = 'июня';
            break;
          case 6:
            localizedMonth = 'июля';
            break;
          case 7:
            localizedMonth = 'августа';
            break;
          case 8:
            localizedMonth = 'сентября';
            break;
          case 9:
            localizedMonth = 'октября';
            break;
          case 10:
            localizedMonth = 'ноября';
            break;
          case 11:
            localizedMonth = 'декабря';
            break;
        }

        return day + ' ' + localizedMonth + ' ' + year;
      }

      function _ceil(val, point){
        return Math.ceil(val / point) * point;
      }

      ctrl.getClass = function(){
        return ctrl.item.selected ? 'selected' : 'unselected';
      };

      ctrl.calcRound = function(p){
        var res;
        switch (ctrl.tmpl.priceRoundRule){
          case PRICE.ROUND_RULES.NONE.id:
            res = p;
            break;
          case PRICE.ROUND_RULES.TO_MATH.id:
            res = Math.round(p);
            break;
          case PRICE.ROUND_RULES.TO_1_UP.id:
            res = _ceil(p, 1);
            break;
          case PRICE.ROUND_RULES.TO_5_UP.id:
            res = _ceil(p, 5);
            break;
          case PRICE.ROUND_RULES.TO_10_UP.id:
            res = _ceil(p, 10);
            break;
        }

        return res;
      };

      ctrl.calcPrice = function(p){
        var res = +p;
        if (ctrl.tmpl.priceChange.percent){
            res += (res/100) * ctrl.tmpl.priceChange.percent;
        }
        if (ctrl.tmpl.priceChange.value){
            res += ctrl.tmpl.priceChange.value;
        }
        return ctrl.calcRound(res);
      };

      ctrl.item.cuttedDescription = true;

      ctrl.today = _getToday();
    }

    var component = {
      templateUrl: 'app/components/productItem/productItem.html',
      controller: productItemCtrl,
      bindings: {
        item: '<',
        tmpl: '<',
        ccy: '<',
        onClick: '<'
      }
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('productDescription', productList());

  /** @ngInject */
  function productList(){
    /** @ngInject */
    function productListCtrl($sce){
      var ctrl = this;

      ctrl.renderHtml = function(partOfDescription){
        return $sce.trustAsHtml(partOfDescription);
      };
    }

    var component = {
      templateUrl: 'app/components/productDescription/productDescription.html',
      controller: productListCtrl,
      bindings: {
        description: '<',
        showMode: '<'
      }
    };

    return component;
  }

})();

(function() {
    'use strict';

    angular
        .module('vzWidget')
        .component('processTemplatePriceRound', processTemplatePriceRound());

    /** @ngInject */
    function processTemplatePriceRound(){
        /** @ngInject */
        function processTemplatePriceRoundCtrl(PRICE){
            var ctrl = this;
            ctrl.priceRoundRules = PRICE.ROUND_RULES;

            if (!ctrl.currentRule) ctrl.currentRule = ctrl.priceRoundRules.NONE.id;
        }

        var component = {
            templateUrl: 'app/components/processTemplatePriceRound/processTemplatePriceRound.html',
            controller: processTemplatePriceRoundCtrl,
            bindings: {
                currentRule: '='
            }
        };

        return component;
    }

})();
(function() {
    'use strict';

    angular
        .module('vzWidget')
        .component('processTemplatePriceChange', processTemplatePriceChange());

    /** @ngInject */
    function processTemplatePriceChange(){
        /** @ngInject */
        function processTemplatePriceChangeCtrl($scope){
            var ctrl = this;

            var _clearPercentWatch;
            var _clearValueWatch;

            ctrl.signs = ['+', '-'];

            function _sign(val){
                return val < 0 ? '-' : '+';
            }

            function _fromSign(sign, val){
                var factor = sign === '+' ? 1 : -1;
                return factor * val;
            }

            if (ctrl.structure.type){
                if (ctrl.structure.type === 'percent'){
                    ctrl.structure.percent = angular.copy(ctrl.structure.active ? (ctrl.structure.method === 'increase' ? ctrl.structure.value : -1 * ctrl.structure.value) : 0);
                    ctrl.structure.value = 0;
                } else {
                    ctrl.structure.value = ctrl.structure.active ? (ctrl.structure.method === 'increase' ? ctrl.structure.value : -1 * ctrl.structure.value) : 0;
                    ctrl.structure.percent = 0;
                }
                delete ctrl.structure.type;
                delete ctrl.structure.active;
                delete ctrl.structure.method;
            }

            $scope.percent = {
                sign: _sign(ctrl.structure.percent),
                val: ctrl.structure.percent ? Math.abs(ctrl.structure.percent) : null
            };

            $scope.value = {
                sign: _sign(ctrl.structure.value),
                val: ctrl.structure.value ? Math.abs(ctrl.structure.value) : null
            };

            _clearPercentWatch = $scope.$watch('percent', function(newVal){
                if (angular.isDefined(newVal.val)) ctrl.structure.percent = _fromSign(newVal.sign, newVal.val);
            }, true);

            _clearValueWatch = $scope.$watch('value', function(newVal){
                if (angular.isDefined(newVal.val))  ctrl.structure.value = _fromSign(newVal.sign, newVal.val);
            }, true);

            $scope.$on('$destroy', function(){
                _clearPercentWatch();
                _clearValueWatch();
            });
        }

        var component = {
            templateUrl: 'app/components/processTemplatePriceChange/processTemplatePriceChange.html',
            controller: processTemplatePriceChangeCtrl,
            bindings: {
                ccy: '@',
                structure: '='
            }
        };

        return component;
    }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('processTemplate', processTemplate());

  var defaultTemplate = {
    "publishLink": true,
    "publishFreq": 5,
    "dupProtection": true,
    "userData": {
      "active": true,
      "value": " + орг. сбор + доставка"
    },
    "publishDescription": false,
    "shortingLinks": true,
    "publishPrice": true,
    "convertion": {
      "active": false,
      "to": {
        "currency": "RUB"
      }
    },
      "priceChange": {
          "method": "decrease",
          "active": false,
          "type": "percent",
          "value": 10
      },
    "priceRound": {
      "active": false
    },
    "description": {
      "publish": true,
      "fields": {
        "size": true,
        "color": true,
        "additionalDescription": true,
        "description": true,
        "pricesList": false,
        "sku": true
      }
    }
  }

  /** @ngInject */
  function processTemplate(){

    /** @ngInject */
    function processTemplateCtrl(communication, storage){
      var ctrl = this;

      function calcRate(toCcy){
        var res = (+ctrl.settings.currencies[ctrl.site.currency])/(+ctrl.settings.currencies[toCcy]);
        return Math.round( res * 100 ) / 100;
      }

      ctrl.currencies = [];
      ctrl.settings = communication.getSettings();

      ctrl.settings.$promise.then(function(rs){
        angular.forEach(rs.currencies, function(v, k){
          ctrl.currencies.push(k);
        });

        defaultTemplate.convertion.to.value = calcRate(defaultTemplate.convertion.to.currency);

        angular.extend(ctrl.tmpl, storage.getProcessTmpl() || defaultTemplate);
      });


      ctrl.waitInterval = [{
        value: 0,
        name: 'Быстрая (без задержки)'
      }, {
        value: 5,
        name: 'Обычная (1 фото в 5 сек.)'
      }, {
        value: 20,
        name: 'Медленная (1 фото в 20 сек.)'
      }];

      ctrl.toCcyChanged = function(){
        ctrl.tmpl.convertion.to.value = calcRate(ctrl.tmpl.convertion.to.currency);
      };
    }

    var component = {
      templateUrl: 'app/components/processTemplate/processTemplate.html',
      controller: processTemplateCtrl,
      bindings: {
        site: '=',
        tmpl: '=',
        props: '='
      }
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('issuesList', issuesList());

  /** @ngInject */
  function issuesList(){
    /** @ngInject */
    function issuesListCtrl(issues, STATES, $rootScope, $scope){
      var ctrl = this;

      function _reaskIssues(){
        ctrl.issues = issues.get();
      }

      _reaskIssues();

      var cleanupEvent = $rootScope.$on(STATES.REASK_ISSUES, function(){
        _reaskIssues();
      });

      $scope.$on('$destroy', function(){
        cleanupEvent();
      });
    }

    var component = {
      templateUrl: 'app/components/issuesList/issuesList.html',
      controller: issuesListCtrl
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('menu', menu());

  /** @ngInject */
  function menu(){
    /** @ngInject */
    function menuCtrl(communication, $state){
      var ctrl = this;

      ctrl.state = $state;
      ctrl.user = communication.getUser();
    }

    var component = {
      templateUrl: 'app/components/menu/menu.html',
      controller: menuCtrl
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('issuesItemUpload', issuesItemUpload());

  /** @ngInject */
  function issuesItemUpload(){
    /** @ngInject */
    function issuesItemUploadCtrl(issues){
      var ctrl = this;

      ctrl.statuses = issues.getStatuses();
    }

    var component = {
      templateUrl: 'app/components/issuesItemUpload/issuesItemUpload.html',
      controller: issuesItemUploadCtrl,
      bindings: {
        item: '<'
      }
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('issuesItemCrawl', issuesItemCrawl());

  /** @ngInject */
  function issuesItemCrawl(){
    /** @ngInject */
    function issuesItemCrawlCtrl(issues){
      var ctrl = this;

      ctrl.statuses = issues.getStatuses();
    }

    var component = {
      templateUrl: 'app/components/issuesItemCrawl/issuesItemCrawl.html',
      controller: issuesItemCrawlCtrl,
      bindings: {
        item: '<'
      }
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('issuesItem', issuesItem());

  /** @ngInject */
  function issuesItem(){
    /** @ngInject */
    function issuesItemCtrl(issues, $sce){
      var ctrl = this;

      ctrl.cancelIssue = function(i){
        issues.cancel(i.id).$promise.then(function(rs){
          angular.extend(i, rs);
        });
      };

      ctrl.checkCancellationSupport = function(i){
        return i.supportCancellation && (i.status === issues.getStatuses().NEW || i.status === issues.getStatuses().PROCESS);
      };

      ctrl.getLinkToAlbum = function(albumId){
        return 'https://vzakupke.com/#/album/' + albumId;
      };

      ctrl.renderHtml = function(html){
        return $sce.trustAsHtml(html);
      };
    }

    var component = {
      templateUrl: 'app/components/issuesItem/issuesItem.html',
      controller: issuesItemCtrl,
      bindings: {
        item: '<'
      }
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('groupList', groupList());

  /** @ngInject */
  function groupList(){

    var component = {
      templateUrl: 'app/components/groupList/groupList.html',
      bindings: {
        groups: '<',
        onClick: '<'
      }
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('groupItem', groupItem());

  /** @ngInject */
  function groupItem(){

    var component = {
      templateUrl: 'app/components/groupItem/groupItem.html',
      bindings: {
        item: '<',
        onClick: '<'
      }
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('finalMessage', finalMessage());

  /** @ngInject */
  function finalMessage(){

    var component = {
      templateUrl: 'app/components/finalMessage/finalMessage.html',
      bindings: {
        storeToAnotherSource: '&',
        continue: '&',
        cleanAndContinue: '&'
      }
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('fileExport', fileExport());

  /** @ngInject */
  function fileExport(){

    var component = {
      templateUrl: 'app/components/fileExport/fileExport.html',
      bindings: {
        exportToFile: '<'
      }
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('currencyConverter', currencyConverter());

  /** @ngInject */
  function currencyConverter(){
    /** @ngInject */
    function currencyConverterCtrl(){
      var ctrl = this;

      ctrl.convert = function(){
        var res = ctrl.val * ctrl.toRate;
        return ctrl.priceChangeCb ? ctrl.priceChangeCb(res) : res;
      };
    }

    var component = {
      template: '<span ng-bind="$ctrl.convert() | number : 2"></span>',
      controller: currencyConverterCtrl,
      bindings: {
        val: '=',
        toRate: '<',
        priceChangeCb: '<'
      }
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('albumList', albumList());

  /** @ngInject */
  function albumList(){
    /** @ngInject */
    function albumListCtrl(){
      var ctrl = this;

      ctrl.nextResultPortion = function(){
        ctrl.onScroll();
      };

      ctrl.scrollIsDisabled = function(){
        return ctrl.albums.loading || !ctrl.albums.hasMore;
      };
    }

    var component = {
      templateUrl: 'app/components/albumList/albumList.html',
      controller: albumListCtrl,
      bindings: {
        albums: '<',
        onScroll: '<',
        scrollContainer: '@',
        onClick: '<',
        onCreate: '<',
        onProcess: '<',
        currentGroup: '<'
      }
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('albumItem', albumItem());

  /** @ngInject */
  function albumItem(){

    var component = {
      templateUrl: 'app/components/albumItem/albumItem.html',
      bindings: {
        item: '<',
        onClick: '<',
        onProcess: '<'
      }
    };

    return component;
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .component('albumCreate', albumCreate());

  /** @ngInject */
  function albumCreate(){
    /** @ngInject */
    function albumCreateCtrl(album){
      var ctrl = this;

      ctrl.create = function(){
        ctrl.process = album.create({
          title: ctrl.albumTitle,
          groupId: ctrl.currentGroup.id
        });
        ctrl.process.$promise.then(function(){
          ctrl.albumTitle = null;
          ctrl.onCreate();
        });
      }
    }

    var component = {
      templateUrl: 'app/components/albumCreate/albumCreate.html',
      controller: albumCreateCtrl,
      bindings: {
        onCreate: '<',
        canCreate: '<',
        currentGroup: '<'
      }
    };

    return component;
  }

})();

(function() {
  'use strict';
  angular
    .module('vzWidget')
    .controller('RootController', RootController);

  /** @ngInject */
  function RootController(communication){
    var ctrl = this;
    ctrl.user = communication.getUser();
  }
})();

(function() {
  'use strict';
  angular
    .module('vzWidget')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController(STATES, VZ_API, $element, $window){
    var vm = this;
    var background = $element[0].querySelector('.background');

    function setBackgroundSize(){
      background.style.height = $window.innerHeight + 'px';
    }

    $window.onresize = setBackgroundSize;

    setBackgroundSize();

    vm.login = function(){
      $window.open(VZ_API.LOGIN, 'VZ', 'width=500,height=400');
    };
  }
})();

(function() {
  'use strict';
  angular
    .module('vzWidget')
    .controller('IssuesController', IssuesController);

  /** @ngInject */
  function IssuesController(communication){
    var ctrl = this;

    ctrl.user = communication.getUser();
  }
})();

(function() {
  'use strict';
  angular
    .module('vzWidget')
    .controller('InstructionController', InstructionController);

  /** @ngInject */
  function InstructionController(){
  }
})();

(function() {
  'use strict';
  angular
    .module('vzWidget')
    .controller('ErrorController', ErrorController);

  /** @ngInject */
  function ErrorController($stateParams){
    var ctrl = this;

    ctrl.code = +$stateParams.errorCode;
  }
})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .run(runBlock);

  /** @ngInject */
  function runBlock() {

    //$log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .config(routerConfig)
    .factory('routeEvents', routeEvents)
    .run(routerRunner);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider){
    $stateProvider
      .state('root', {
        url: '/',
        templateUrl: 'app/root/root.html',
        controller: 'RootController',
        controllerAs: '$ctrl'
      })
      .state('example', {
        url: '/example',
        templateUrl: 'app/example/example.html',
        controller: 'ExampleController',
        controllerAs: '$ctrl'
      })
      .state('login', {
        url: '/login',
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: '$ctrl'
      })
      .state('issues', {
        url: '/issues',
        templateUrl: 'app/issues/issues.html',
        controller: 'IssuesController',
        controllerAs: '$ctrl'
      })
      .state('error', {
        url: '/error/:errorCode',
        templateUrl: 'app/error/error.html',
        controller: 'ErrorController',
        controllerAs: '$ctrl'
      })
      .state('instruction', {
        url: '/instruction',
        templateUrl: 'app/instruction/instruction.html',
        controller: 'InstructionController',
        controllerAs: '$ctrl'
      });

    $urlRouterProvider.otherwise('/');
  }

  /** @ngInject */
  function routeEvents(STATES, messageSender, $rootScope, $state){
    function _start(){
      var onAuthCompleteCleanUp = $rootScope.$on(STATES.ON_AUTH_COMPLETE, function(){
        $state.go('root')
      });

      var onAuthCleanUp = $rootScope.$on(STATES.ON_AUTHORIZED, function(){
        messageSender.userAuthorized();
      });

      var onUnauthCleanUp = $rootScope.$on(STATES.ON_UNAUTHORIZED, function(){
        messageSender.userUnauthorized();
        $state.go('login')
      });

      var onSubscriptionsReceivedCleanUp = $rootScope.$on(STATES.ON_SUBSCRIPTIONS_RECEIVED, function(event, expiration, statLink){
        messageSender.userIsProvider(expiration, statLink);
      });

      var onErrorCleanUp = $rootScope.$on(STATES.ON_ERROR, function(event, errorCode){
        $state.go('error', {errorCode: errorCode})
      });

      $rootScope.$on('$destroy', function(){
        onAuthCompleteCleanUp();
        onAuthCleanUp();
        onUnauthCleanUp();
        onErrorCleanUp();
        onSubscriptionsReceivedCleanUp();
      });
    }

    return {
      start: _start
    };
  }

  /** @ngInject */
  function routerRunner(routeEvents){
    routeEvents.start();
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .run(messageListenerRunner);

  /** @ngInject */
  function messageListenerRunner(messageListener, messageSender){
    messageListener.start();
    messageSender.start();
  }

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .factory('httpErrorHandler', httpErrorHandler)
    .config(handError);

  /** @ngInject */
  function httpErrorHandler(STATES, $q, $rootScope){
    return {
      'responseError': function(rejection){
        if (rejection.status === 401){
          $rootScope.$emit(STATES.ON_UNAUTHORIZED);
        } else {
          $rootScope.$emit(STATES.ON_ERROR, rejection.status);
        }
        return $q.reject(rejection);
      }
    }
  }

  /** $ngInject */
  function handError($httpProvider){
    $httpProvider.interceptors.push('httpErrorHandler');
  }

})();

/* global malarkey:false, moment:false, $:false */
(function() {
  'use strict';

  var STATES = {
    ON_AUTHORIZED: 'ON_AUTHORIZED',
    ON_ERROR: 'ON_ERROR',
    ON_UNAUTHORIZED: 'ON_UNAUTHORIZED',
    ON_AUTH_COMPLETE: 'ON_AUTH_COMPLETE',
    ON_SITE_SETUP: 'ON_SITE_SETUP',
    ON_SUBSCRIPTIONS_RECEIVED: 'ON_SUBSCRIPTIONS_RECEIVED',
    TRY_AUTHORIZE: 'TRY_AUTHORIZE',
    PRODUCTS_SELECTED: 'PRODUCTS_SELECTED',
    REASK_PRODUCTS: 'REASK_PRODUCTS',
    REASK_ISSUES: 'REASK_ISSUES',
    STORE_WITH_LAST_SOURCE: 'STORE_WITH_LAST_SOURCE',
    PRODUCTS_EXPORT_TO_FILE: 'PRODUCTS_EXPORT_TO_FILE'
  };

  var PRICE = {
    ROUND_RULES: {
      NONE:     {id: 'none', title: 'Без округления'},
      TO_MATH:  {id: 'toMath', title: 'До ближайшего целого'},
      TO_1_UP:  {id: 'to1Up', title: 'До 1 вверх'},
      TO_5_UP:  {id: 'to5Up', title: 'До 5 вверх'},
      TO_10_UP: {id: 'to10Up', title: 'До 10 вверх'}
    }
  };

  angular
    .module('vzWidget')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('jq', $)
    .constant('STATES', STATES)
    .constant('PRICE', PRICE);

})();

(function() {
  'use strict';

  angular
    .module('vzWidget')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

(function() {
  'use strict';

  function MAKE_STAT_LINK(providerId){
    return 'https://vzakupke.com/#/providers/' + providerId;
  }

  var VZ_PREFIX = '',
      VZ_AUTH_COMPLETE_PAGE = VZ_PREFIX + '/widget/auth_complete.html',
      VZ_API_PREFIX = VZ_PREFIX + '/api',
      VZ_WIDGET_PREFIX = VZ_API_PREFIX + '/widget',
      VZ_API = {
        ROOT: VZ_PREFIX,
        LOGIN: VZ_PREFIX + '/api/login?callbackUrl=' + VZ_AUTH_COMPLETE_PAGE,
        ALBUMS: VZ_API_PREFIX + '/albums',
        ISSUES: VZ_API_PREFIX + '/issues',
        MAKE_STAT_LINK: MAKE_STAT_LINK,
        STORE_PRODUCTS: VZ_API_PREFIX + '/albums/:albumId/products/process/store',
        SETTINGS: VZ_API_PREFIX + '/settings',
        SUBSCRIPTIONS: VZ_API_PREFIX + '/subscriptions?flat=true',
        USER_GROUPS: VZ_API_PREFIX + '/user/groups',
        WIDGET_ASK_PRODUCTS_COUNTER: VZ_WIDGET_PREFIX + '/countProducts',
        WIDGET_CRAWL: VZ_WIDGET_PREFIX + '/crawl',
        WIDGET_EXPORT: VZ_WIDGET_PREFIX + '/export',
        WIDGET_INIT: VZ_WIDGET_PREFIX + '/init',
        WIDGET_ISSUES: VZ_WIDGET_PREFIX + '/issues',
        WIDGET_PRODUCTS: VZ_WIDGET_PREFIX + '/products',
        WIDGET_SIZES: VZ_WIDGET_PREFIX + '/sizes',
        WIDGET_USER: VZ_WIDGET_PREFIX + '/user'
      };

  angular
    .module('vzWidget')
    .constant('VZ_API', VZ_API);

})();

angular.module("vzWidget").run(["$templateCache", function($templateCache) {$templateCache.put("app/error/error.html","<div class=error-page><div class=\"col-xs-7 error-wrapper\"><div class=payment-error ng-if=\"$ctrl.code === 402\"><h1 class=\"text-danger text-center\">Подписка не была продлена поставщиком</h1><p class=\"description text-center\">Чтобы продолжить работу вы можете:<br>связаться с поставщиком, поучавствовать в <a href=\"https://new.vk.com/vzakupkecom?w=page-98482725_52220685\" target=_blank>нашей акции</a> или приобрести <a href=https://vzakupke.com/#/#price target=_blank>персональную подписку</a>.</p></div><div class=other-error ng-if=\"$ctrl.code !== 402\"><h1 class=\"text-danger text-center\">Произошла ошибка сервиса</h1><p class=\"description text-center\"><a href=\"https://new.vk.com/im?fail_try=0&media=&sel=-98482725\" target=_blank>Сообщите о проблеме</a> нашей команде технической поддержки и мы приложим все усилия, чтобы решить ее в кратчайшие сроки!</p></div></div><div class=\"image-wrapper col-xs-5\"><img src=./assets/images/error.png></div></div>");
$templateCache.put("app/instruction/instruction.html","<div class=\"instruction-page col-xs-12\"><h1 class=\"text-vz text-center margin-top-dbl margin-bottom-dbl\">Инструкция работы с виджетом ВЗакупке</h1><section class=list-group><a ui-sref=\"instruction({\'#\': \'widget-features\'})\" class=list-group-item>Возможности виджета ВЗакупке</a> <a ui-sref=\"instruction({\'#\': \'widget-store-products\'})\" class=list-group-item>Выкладка товаров в ВК</a> <a ui-sref=\"instruction({\'#\': \'widget-export-products\'})\" class=list-group-item>Экспорт товаров в файл для сайта или форума (XLSX, CSV)</a> <a ui-sref=\"instruction({\'#\': \'widget-issues\'})\" class=list-group-item>Отмена выкладки</a> <a ui-sref=\"instruction({\'#\': \'widget-report\'})\" class=list-group-item>Формирование отчета по закупкам</a></section><section id=widget-features class=\"instruction-section margin-bottom-dbl row\"><h3 class=\"text-vz text-center margin-bottom-dbl\">С нами вы сможете:</h3><div class=\"col-sm-6 col-xs-12\"><img src=./assets/images/instruction/1.png></div><div class=\"col-sm-6 col-xs-12\"><ul class=feature-list><li>выложить необходимый каталог в ВК или на свой сайт в несколько кликов не покидая сайт;</li><li>НЕ ЖДАТЬ окончания выкладки и заниматься своими делами;</li><li>обработать любое количество каталогов и выложить все сразу или поэтапно;</li><li>выкладывать выбранные товары в несколько альбомов одновременно;</li><li>сформировать excel файл отчета по закупкам в несколько кликов!</li></ul></div></section><section id=widget-store-products class=\"instruction-section margin-bottom-dbl row\"><h3 class=\"text-vz text-center margin-bottom-dbl\">Выкладка товаров в ВК</h3><div class=\"col-xs-12 clearfix\"><ul rn-carousel rn-carousel-controls rn-carousel-swipe=false class=image><li class=slide-1><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"><h4>Шаг 1:</h4></div><div class=\"col-sm-10 col-md-11\"><p>Перейдите на необходимую категорию сайта и нажмите кнопку <b>\"Получить\"</b>.<br>Вы можете получать товары из нескольких категорий одновременно.<br>Индикатор с цифрами правее кнопки <b>\"Получить\"</b> отображает прогресс получения товаров из категорий сайта.</p></div><img class=center-block src=./assets/images/instruction/2.1.png></div></div></li><li class=slide-2><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"><h4>Шаг 2:</h4></div><div class=\"col-sm-10 col-md-11\"><p>После того, как все задачи на получение товаров будут обработаны, индикатор правее кнопки <b>\"Получить\"</b> загорится зеленым цветом и разблокируется кнопка <b>\"Выложить\"</b>.<br>Кликнув по ней мы перейдем к процессу выкладки.</p></div><img class=center-block src=./assets/images/instruction/2.2.png></div></div></li><li class=slide-3><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"><h4>Шаг 3:</h4></div><div class=\"col-sm-10 col-md-11\"><p>На данном этапе вы можете выбрать из списка товары, необходимые для выкладки и отредактировать шаблон выделенный зеленой рамкой (например: увеличить или конвертировать цену, изменить скорость выкладки в соц. сеть и т.д.)<br><br>Далее вы можете перейти к выбору группы и альбома (кликнув по кнопке <b>\"Выложить\"</b>) или сразу выложить в группу и альбом, которые использовались ранее.<br>Кнопка <b>\"Отменить - это не то, что мне нужно\"</b> очищает список полученных товаров и выполненные задачи.</p></div><img class=center-block src=./assets/images/instruction/2.3.png></div></div></li><li class=slide-4><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"><h4>Шаг 4:</h4></div><div class=\"col-sm-10 col-md-11\"><p>Теперь вам необходимо выбрать группу и альбом для выкладки товаров, а затем кликнуть по кнопке <b>\"Выложить\"</b> напротив выбранного альбома.<br><br>Также вы можете создать новый альбом в выбранной группе.</p></div><img class=center-block src=./assets/images/instruction/2.4.png></div></div></li><li class=slide-5><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"><h4>Шаг 5:</h4></div><div class=\"col-sm-10 col-md-11\"><p>Поздравляем! Вы успешно произвели свою первую выкладку! Далее вы можете:<br>- выключить компьютер и заниматься своими делами, наш сервис все закончит без вашего участия;<br>- очистить список полученных товаров и начать работать со следующей категорией (кликнув по кнопке <b>\"Очистить товары и продолжить работу\"</b>);<br>- выложить уже готовый список товаров в другой альбом (кликнув по кнопке <b>\"Выложить в другой альбом\"</b>).</p></div><img class=center-block src=./assets/images/instruction/2.5.png></div></div></li><li class=slide-6><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"></div><div class=\"col-sm-10 col-md-11\"><p>Индикатор с цифрами правее кнопки <b>\"Выложить\"</b> отображает прогресс выкладки в соц. сеть.<br>Как только он загорится зеленым цветом - все задачи на выкладку закончены!</p></div><img class=center-block src=./assets/images/instruction/2.6.png></div></div></li></ul></div></section><section id=widget-export-products class=\"instruction-section margin-bottom-dbl row\"><h3 class=\"text-vz text-center margin-bottom-dbl\">Экспорт товаров в файл для сайта или форума (XLSX, CSV)</h3><div class=\"col-xs-12 clearfix\"><ul rn-carousel rn-carousel-controls rn-carousel-swipe=false class=image><li class=slide-1><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"><h4>Шаг 1:</h4></div><div class=\"col-sm-10 col-md-11\"><p>Перейдите на необходимую категорию сайта и нажмите кнопку <b>\"Получить\"</b>.<br>Вы можете получать товары из нескольких категорий одновременно.<br>Индикатор с цифрами правее кнопки <b>\"Получить\"</b> отображает прогресс получения товаров из категорий сайта.</p></div><img class=center-block src=./assets/images/instruction/2.1.png></div></div></li><li class=slide-2><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"><h4>Шаг 2:</h4></div><div class=\"col-sm-10 col-md-11\"><p>После того, как все задачи на получение товаров будут обработаны, индикатор правее кнопки <b>\"Получить\"</b> загорится зеленым цветом и разблокируется кнопка <b>\"Выложить\"</b>.<br>Кликнув по ней мы перейдем к процессу выкладки.</p></div><img class=center-block src=./assets/images/instruction/2.2.png></div></div></li><li class=slide-3><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"><h4>Шаг 3:</h4></div><div class=\"col-sm-10 col-md-11\"><p>На данном этапе вы можете выбрать из списка товары, необходимые для выкладки и отредактировать шаблон выделенный зеленой рамкой (например: увеличить или конвертировать цену, изменить скорость выкладки в соц. сеть и т.д.)<br><br>Чтобы начать экспорт товаров, кликните по кнопке <b>\"Экспорт в файл\"</b></p></div><img class=center-block src=./assets/images/instruction/3.3.png></div></div></li><li class=slide-4><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"><h4>Шаг 4:</h4></div><div class=\"col-sm-10 col-md-11\"><p>Как только вы увидите ссылки на скачивание файла в форматах CSV и Excel - экспорт завершен!<br>Вы можете скачать любой, просто кликнув по ссылке!<br><br>В зависимости от количества выбранных товаров, экспорт может занимать длительное время.</p></div><img class=center-block src=./assets/images/instruction/3.4.png></div></div></li></ul></div></section><section id=widget-issues class=\"instruction-section margin-bottom-dbl row\"><h3 class=\"text-vz text-center margin-bottom-dbl\">Отмена выкладки</h3><div class=\"col-xs-12 clearfix\"><ul rn-carousel rn-carousel-controls rn-carousel-swipe=false class=image><li class=slide-1><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"><h4>Шаг 1:</h4></div><div class=\"col-sm-10 col-md-11\"><p>Кликните по ссылке <b>\"Активные задачи\"</b> в виджете.<br><br>Индикаторы правее кнопок <b>\"Получить\"</b> и <b>\"Выложить\"</b> показывают суммарное количество обрабатываемых элементов со всех задач. Детально ознакомиться с количеством обрабатываемых элементов для каждой задачи можно после перехода в \"Активные задачи\".</p></div><img class=center-block src=./assets/images/instruction/4.1.png></div></div></li><li class=slide-2><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"><h4>Шаг 2:</h4></div><div class=\"col-sm-10 col-md-11\"><p>Для отмены выкладки, кликните по ссылке <b>\"Отменить задачу\"</b> в правом углу задачи, которую вы хотите прервать.<br>После этого выкладка остановится и задача пометится как отмененная.</p></div><img class=center-block src=./assets/images/instruction/4.2.png></div></div></li></ul></div></section><section id=widget-report class=\"instruction-section margin-bottom-dbl row\"><h3 class=\"text-vz text-center margin-bottom-dbl\">Формирование отчета по закупкам</h3><div class=\"col-xs-12 clearfix\"><ul rn-carousel rn-carousel-controls rn-carousel-swipe=false class=image><li class=slide-1><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"><h4>Шаг 1:</h4></div><div class=\"col-sm-10 col-md-11\"><p>Откройте сайт <a href=https://vzakupke.com target=_blank>ВЗакупке</a>. Если необходимая вам группа отсутствует на рабочем столе, кликните по кнопке \"+\" для добавления группы.<br>Если группа была добавлена ранее, то <b>\"Шаг 2\"</b> необходимо пропустить.<br><b>ВНИМАНИЕ!</b> Отчет содержит макисмально корректную информацию для товаров, которые были выгружены с помощью сервиса <a href=https://vzakupke.com target=_blank>ВЗакупке</a>!</p></div><img class=center-block src=./assets/images/instruction/5.1.png></div></div></li><li class=slide-2><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"><h4>Шаг 2:</h4></div><div class=\"col-sm-10 col-md-11\"><p>Найдите необходимую группу и кликните по ней</p></div><img class=center-block src=./assets/images/instruction/5.2.png></div></div></li><li class=slide-3><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"><h4>Шаг 3:</h4></div><div class=\"col-sm-10 col-md-11\"><p>На рабочем столе найдите альбом, по которому вы планируете создать отчет по закупкам и кликните по нему</p></div><img class=center-block src=./assets/images/instruction/5.3.png></div></div></li><li class=slide-4><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"><h4>Шаг 4:</h4></div><div class=\"col-sm-10 col-md-11\"><p>Кликните по кнопке <b>\"Сформировать отчет\"</b></p></div><img class=center-block src=./assets/images/instruction/5.4.png></div></div></li><li class=slide-5><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"><h4>Шаг 5:</h4></div><div class=\"col-sm-10 col-md-11\"><p>Далее вы можете выбрать временной промежуток, за который вы хотите собрать комментарии в альбоме. Если вы хотите собрать комментарии за весь период существования альбома, даты выбирать не нужно.<br>Затем кликните по кнопке <b>\"Экспортировать заказы в Excel\"</b></p></div><img class=center-block src=./assets/images/instruction/5.5.png></div></div></li><li class=slide-5><div class=layer><div class=info><div class=\"col-sm-2 col-md-1\"><h4>Шаг 6:</h4></div><div class=\"col-sm-10 col-md-11\"><p>Теперь дождитесь завершения задачи и кликните по ссылке <b>\"Скачать\"</b>, после чего начнется скачивание отчета на ваш компьютер.<br>Поздравляем, отчет сформирован!</p></div><img class=center-block src=./assets/images/instruction/5.6.png></div></div></li></ul></div></section></div>");
$templateCache.put("app/issues/issues.html","<issues-list ng-if=$ctrl.user.authorized></issues-list>");
$templateCache.put("app/login/login.html","<div class=\"row background login\"><div class=\"vz-title text-vz\"><div class=title><b>ВЗакупке</b></div><span>Быстрое администрирование -</span><br><span>счастливая семья. Экономьте</span><br><span>свое время для близких!</span><br><button ng-click=$ctrl.login() class=\"btn btn-vz work-start\">Начать работу</button></div></div>");
$templateCache.put("app/root/root.html","<state-viewer ng-if=$ctrl.user.authorized></state-viewer>");
$templateCache.put("app/components/albumCreate/albumCreate.html","<div ng-if=$ctrl.canCreate><div class=\"plus-wrapper pull-left\"><i class=\"fa fa-plus\"></i></div><div class=\"input-wrapper form-group\"><div class=input-group><input type=text class=form-control ng-model=$ctrl.albumTitle placeholder=\"Введите название...\"> <span class=input-group-btn><button class=\"btn btn-success\" ng-click=$ctrl.create() ng-disabled=\"!$ctrl.albumTitle || ($ctrl.process && !$ctrl.process.$resolved)\" class=\"btn btn-default\" type=button>Создать альбом</button></span></div></div></div><div ng-if=!$ctrl.canCreate><h5 class=\"warning text-danger\">ВК не позволяет создать более 2000 альбомов в группе</h5></div>");
$templateCache.put("app/components/albumItem/albumItem.html","<div class=\"clearfix album-wrapper\" ng-class=\"{\'selected\': $ctrl.item.selected}\" ng-click=$ctrl.onClick($ctrl.item)><a ng-href={{::$ctrl.item.url}} target=_blank><div class=\"preview-container pull-left\" ng-style=\"::{\'background-image\':\'url({{::$ctrl.item.preview}})\'}\"></div></a><div class=\"title-container text-center pull-left\"><h4 class=\"text-vz ellipsis\" ng-bind=::$ctrl.item.name uib-tooltip={{::$ctrl.item.name}} tooltip-placement=right></h4></div><button ng-if=$ctrl.item.selected class=\"process-btn btn btn-success\" ng-click=$ctrl.onProcess()>Выложить</button></div>");
$templateCache.put("app/components/albumList/albumList.html","<div class=\"album-wrapper clearfix\" infinite-scroll=$ctrl.nextResultPortion() infinite-scroll-distance=1 infinite-scroll-disabled=$ctrl.scrollIsDisabled() infinite-scroll-container=$ctrl.scrollContainer><album-create can-create=\"$ctrl.albums.size < 2000\" on-create=$ctrl.onCreate current-group=$ctrl.currentGroup></album-create><album-item ng-repeat=\"item in $ctrl.albums.data track by item.id\" item=item on-click=$ctrl.onClick on-process=$ctrl.onProcess></album-item><spinner spinner-show=$ctrl.albums.loading spinner-size=80></spinner></div>");
$templateCache.put("app/components/fileExport/fileExport.html","<div class=\"selector animated fadeIn\" ng-if=$ctrl.exportToFile.$resolved><div class=\"col-xs-4 image-wrapper\"><img src=./assets/images/export-file.png></div><div class=\"col-xs-8 links-wrapper\"><a class=\"link-vz link-to-file\" ng-href={{$ctrl.exportToFile.data.csv}}><i class=\"fa fa-cloud-download\" aria-hidden=true></i>Скачать CSV файл</a><br><br><a class=\"link-vz link-to-file\" ng-href={{$ctrl.exportToFile.data.xlsx}}><i class=\"fa fa-cloud-download\" aria-hidden=true></i>Скачать Excel файл</a></div></div><spinner spinner-show=!$ctrl.exportToFile.$resolved spinner-size=80></spinner>");
$templateCache.put("app/components/finalMessage/finalMessage.html","<div class=\"col-xs-8 margin-top-std\"><h3 class=\"text-vz margin-bottom-std\">Товары выкладываются в фоновом режиме. Сейчас вы можете:</h3><ul class=you-can-list><li><b class=text-vz>НЕ ЖДАТЬ!</b> Выключить компьютер и заниматься другими делами - сервис все сделает и без вас;</li><li><b class=text-vz>НЕ ЖДАТЬ</b> и продолжить работу с сайтом. Допустим, работая с симой и отправив на выкладку \"детские коврики\" - вы можете сразу отправить на выкладку, например, \"кружки\" - ваша вторая выкладка встанет в очередь, и сервис начнет выкладывать кружки сразу после того, как выложит коврики.</li></ul><!--<button class=\"btn btn-vz center-block margin-top-dbl\" ng-click=\"$ctrl.continue()\">Продолжить работу</button>--> <button class=\"btn btn-vz center-block margin-top-dbl\" ng-click=$ctrl.cleanAndContinue()>Очистить товары и продолжить работу</button> <button class=\"btn btn-success center-block margin-top-dbl\" ng-click=$ctrl.storeToAnotherSource()>Выложить в другой альбом</button></div><div class=\"col-xs-4 image-wrapper\"><img src=./assets/images/no-wait.png></div>");
$templateCache.put("app/components/groupItem/groupItem.html","<div class=\"group-wrapper clearfix\" ng-class=\"{\'selected\': $ctrl.item.selected}\" ng-click=$ctrl.onClick($ctrl.item)><div class=\"preview-container pull-left\"><a ng-href={{::$ctrl.item.url}} target=_blank><img ng-src={{::$ctrl.item.preview}}></a></div><div class=\"title-container text-center pull-left\"><h4 ng-bind=::$ctrl.item.name class=\"text-vz ellipsis\" uib-tooltip={{::$ctrl.item.name}} tooltip-placement=right></h4></div></div>");
$templateCache.put("app/components/groupList/groupList.html","<group-item ng-repeat=\"item in $ctrl.groups track by item.id\" item=item on-click=$ctrl.onClick></group-item><spinner spinner-show=!$ctrl.groups.$resolved spinner-size=80></spinner>");
$templateCache.put("app/components/issuesItem/issuesItem.html","<div class=\"issue text-center animated fadeIn alert\" role=alert ng-class=$ctrl.item.status><div class=\"action-wrapper pull-right\" ng-show=$ctrl.checkCancellationSupport($ctrl.item) ng-click=$ctrl.cancelIssue($ctrl.item)><a href>Отменить задачу</a></div><div class=\"action-wrapper pull-right\" ng-if=::$ctrl.item.data.album.id><a ng-href={{::$ctrl.getLinkToAlbum($ctrl.item.data.album.id)}} target=_blank>В альбом</a></div><div class=issue-wrapper ng-switch=$ctrl.item.type><issues-item-upload ng-switch-when=uploadPhotos item=$ctrl.item></issues-item-upload><issues-item-crawl ng-switch-when=crawlSiteByUrl item=$ctrl.item></issues-item-crawl><span ng-if=\"$ctrl.item.status === \'new\' || $ctrl.item.status === \'process\'\"><i class=\"fa fa-fw fa-spin fa-circle-o-notch\"></i> </span><span ng-if=$ctrl.item.internalMessage ng-bind=$ctrl.item.internalMessage></span></div><div class=issue-message ng-if=$ctrl.item.data.message ng-bind-html=$ctrl.renderHtml($ctrl.item.data.message)></div></div>");
$templateCache.put("app/components/issuesItemCrawl/issuesItemCrawl.html","<div class=site-crawl>Получение товаров с сайта \"<strong ng-bind=::$ctrl.item.data.url></strong>\" <span ng-if=\"$ctrl.item.status === $ctrl.statuses.DONE\">завершено.</span> <span ng-if=\"$ctrl.item.status === $ctrl.statuses.ERROR\">. Возникла ошибка.</span></div>");
$templateCache.put("app/components/issuesItemUpload/issuesItemUpload.html","<div class=photo-upload>Выкладка фотографий в альбом \"<strong ng-bind=::$ctrl.item.data.album.name></strong>\" из группы \"<span ng-bind=::$ctrl.item.data.album.links.group.name></span>\" <span ng-if=\"$ctrl.item.status === $ctrl.statuses.DONE\">завершена. Выложено: <span ng-bind=::$ctrl.item.data.progress.processed></span></span> <span ng-if=\"$ctrl.item.status === $ctrl.statuses.PROCESS.NEW || $ctrl.item.status === $ctrl.statuses.PROCESS\">: <span ng-bind=$ctrl.item.data.progress.processed></span> из <span ng-bind=$ctrl.item.data.progress.planned></span> </span><span ng-if=\"$ctrl.item.status === $ctrl.statuses.REJECTED\">. Задача отменена, выложено <span ng-bind=::$ctrl.item.data.progress.processed></span> из <span ng-bind=::$ctrl.item.data.progress.planned></span>. </span><span ng-if=\"$ctrl.item.status === $ctrl.statuses.ERROR\">. Возникла ошибка.</span></div>");
$templateCache.put("app/components/issuesList/issuesList.html","<h1 class=\"text-vz text-center margin-bottom-std\">Мои задачи:</h1><issues-item ng-repeat=\"item in $ctrl.issues.rs track by item.id\" item=item id={{item.id}}></issues-item><spinner spinner-show=\"!$ctrl.issues.rs && !$ctrl.issues.$resolved\" spinner-size=80></spinner><h3 class=\"text-center text-vz margin-top-std\" ng-if=\"$ctrl.issues.$resolved && !$ctrl.issues.rs.length\">Не найдено ни одной активной задачи</h3>");
$templateCache.put("app/components/menu/menu.html","<div class=menu><div class=\"menu-wrapper pull-right clearfix\" ng-if=\"$ctrl.user.authorized && $ctrl.state.current.name !== \'error\'\"><div class=\"animated fadeIn label label-vz label-big menu-item\" ng-if=\"$ctrl.state.current.name !== \'root\'\"><a class=no-link-styles-transparent ui-sref=root>Выложить товары</a></div><div class=\"animated fadeIn label label-vz label-big menu-item\" ng-if=\"$ctrl.state.current.name !== \'issues\'\"><a class=no-link-styles-transparent ui-sref=issues>Мои задачи</a></div><div class=user-photo><a href=https://vzakupke.com target=_blank><img class=\"img img-circle\" ng-src={{$ctrl.user.rs.image}} uib-tooltip={{$ctrl.user.rs.name}} tooltip-placement=left></a></div></div></div>");
$templateCache.put("app/components/processTemplate/processTemplate.html","<!-- Frequency slider --><div class=\"control-section first-control\"><label class=text-vz for=publishFreq>Скорость выкладки фотографий</label><select class=form-control id=publishFreq ng-model=$ctrl.tmpl.publishFreq ng-options=\"interval.value as interval.name for interval in $ctrl.waitInterval\"></select><span ng-if=\"$ctrl.tmpl.publishFreq < 5\" class=\"text-danger animated fadeIn\">Внимание, ВК может <a href=https://vk.com/wall-98482725_1288 target=_blank>заблокировать ваш аккаунт!</a></span> <a ng-if=\"$ctrl.tmpl.publishFreq > 5\" class=\"animated fadeIn\" href=https://vk.com/wall-98482725_125 target=_blank>зачем это нужно?</a></div><!-- Duplicate protection --><!--<div class=\"control-section\">--><!--<label ng-show=\"$ctrl.props.hasPrice\">--><!--<input ng-model=\"$ctrl.tmpl.dupProtection\" type=\"checkbox\"> <strong>Защита от дубликатов</strong>--><!--</label>--><!--</div>--><!-- Link publication --><div class=control-section><div class=\"checkbox row\"><div class=col-xs-12><label><input ng-model=$ctrl.tmpl.publishLink type=checkbox> <strong>Ссылка на продукт</strong></label></div></div></div><!-- Has price --><div class=control-section><div class=checkbox><label ng-show=$ctrl.props.hasPrice><input ng-model=$ctrl.tmpl.publishPrice type=checkbox> <strong>Цена продукта</strong></label><p class=text-danger ng-hide=$ctrl.props.hasPrice>Извините, у товаров данного сайта недоступна цена</p></div><div class=\"animated fadeIn\" ng-show=$ctrl.tmpl.publishPrice><!-- Price change --><process-template-price-change structure=$ctrl.tmpl.priceChange ccy={{$ctrl.tmpl.convertion.to.currency}}></process-template-price-change><!-- Price conversion --><div class=checkbox><label><input ng-model=$ctrl.tmpl.convertion.active type=checkbox> <strong>Конвертировать цену (из валюты <span ng-bind=::$ctrl.site.currency></span>)</strong></label></div><div class=\"convertion-variants clearfix animated fadeIn\" ng-show=$ctrl.tmpl.convertion.active><div class=col-xs-6><label for=to-ccy>В валюту</label><div class=vz-select><select class=form-control id=to-ccy ng-change=$ctrl.toCcyChanged() ng-model=$ctrl.tmpl.convertion.to.currency ng-options=\"c for c in $ctrl.currencies\"></select></div></div><div class=col-xs-6><label for=to-val>Текущий курс</label><input class=form-control id=to-val ng-model=$ctrl.tmpl.convertion.to.value type=number min=0></div></div><!-- Price round --><process-template-price-round current-rule=$ctrl.tmpl.priceRoundRule></process-template-price-round></div></div><!-- Publish user info --><div class=control-section><div class=\"form-group animated fadeIn\" ng-show=$ctrl.tmpl.userData.active><label for=user-data>Пользовательская информация</label><input type=text class=form-control id=user-data placeholder=150-200р. ng-model=$ctrl.tmpl.userData.value></div></div><!-- Publish description --><div class=control-section><div class=checkbox><div ng-show=\"$ctrl.props.hasDescription && $ctrl.tmpl.description.publish\" class=row><div class=\"description-field col-xs-6\" ng-repeat=\"field in $ctrl.props.descriptionFields\"><label ng-show=$ctrl.props.hasDescription><input ng-model=$ctrl.tmpl.description.fields[field.id] type=checkbox> <strong ng-bind=::field.title></strong></label></div></div><p class=text-danger ng-hide=$ctrl.props.hasDescription>Извините, у товаров данного сайта недоступно описание</p></div></div>");
$templateCache.put("app/components/processTemplatePriceChange/processTemplatePriceChange.html","<div class=row><div class=\"form-group col-xs-6 col-md-3\"><label class=label-empty for=percentSign></label><div class=vz-select><select ng-model=percent.sign class=form-control name=percentSign ng-options=\"sign for sign in $ctrl.signs\" required></select></div></div><div class=\"form-group col-xs-6 col-md-3\"><label for=percent>%</label><input class=form-control name=percent ng-model=percent.val type=number min=0 placeholder=0 step=any></div><div class=\"form-group col-xs-6 col-md-3\"><label class=label-empty for=valueSign></label><div class=vz-select><select ng-model=value.sign class=form-control name=valueSign ng-options=\"sign for sign in $ctrl.signs\" required></select></div></div><div class=\"form-group col-xs-6 col-md-3\"><label for=value ng-bind=$ctrl.ccy></label><input class=form-control name=value ng-model=value.val type=number min=0 placeholder=0 step=any></div></div>");
$templateCache.put("app/components/processTemplatePriceRound/processTemplatePriceRound.html","<div class=\"control-section clearfix row\"><div class=col-xs-12><label>Округление цены</label><div class=vz-select><select class=form-control id=conversion-rules ng-model=$ctrl.currentRule ng-options=\"r.id as r.title for r in $ctrl.priceRoundRules\"></select></div></div></div>");
$templateCache.put("app/components/productDescription/productDescription.html","<div ng-repeat=\"item in $ctrl.description.fields track by item.id\" ng-if=$ctrl.showMode[item.id] class=\"animated fadeIn\"><strong ng-bind=::item.title></strong><strong>:</strong> <span ng-bind-html=::$ctrl.renderHtml(item.value)></span></div>");
$templateCache.put("app/components/productItem/productItem.html","<section class=\"vk-content item-wrapper\" ng-class=$ctrl.getClass() ng-click=$ctrl.onClick($ctrl.item)><div class=\"variant-indicator text-vz\" ng-if=$ctrl.item.isVariant><i class=\"fa fa-picture-o\"></i></div><div class=select-indicator ng-show=$ctrl.item.selected><i class=\"fa fa-check\"></i></div><div class=\"wrapper clearfix\"><div class=preview><a class=product-preview-wrapper href><img class=\"product-preview center-block\" ng-src={{$ctrl.item.preview}}></a></div><div class=\"col-xs-12 information\"><!--<div class=\"album-info pull-right\">--><!--<div class=\"user-info\">--><!--<div class=\"info-wrapper pull-right\">--><!--<span class=\"user-name\"><a ng-href=\"http://vk.com/id{{user.uid}}\" target=\"_blank\">{{user.first_name}} {{user.last_name}}</a></span>--><!--<br/>--><!--<div class=\"ellipsis\">--><!--<span class=\"album-title\"><a href>Ваш альбом</a></span>--><!--</div>--><!--</div>--><!--<div class=\"avatar-wrapper\">--><!--<img class=\"avatar\" ng-src=\"{{user.photo_50}}\"/>--><!--</div>--><!--</div>--><!--</div>--><div class=description><section class=item-description ng-class=\"{\'cutted\': $ctrl.item.cuttedDescription}\"><a ng-href={{::$ctrl.item.url}} class=\"animated fadeIn\" target=_blank ng-if=$ctrl.tmpl.publishLink ng-click=$event.stopPropagation();><h5 class=product-title ng-bind=::$ctrl.item.name></h5></a><h5 class=\"product-title animated fadeIn\" ng-bind=::$ctrl.item.name ng-if=!$ctrl.tmpl.publishLink></h5><div ng-if=$ctrl.tmpl.publishPrice><span ng-hide=$ctrl.tmpl.convertion.active class=\"animated fadeIn\"><span ng-bind=$ctrl.calcPrice($ctrl.item.price)></span> <span ng-bind=$ctrl.ccy></span> </span><span ng-show=$ctrl.tmpl.convertion.active class=\"animated fadeIn\"><currency-converter val=$ctrl.item.price to-rate=$ctrl.tmpl.convertion.to.value price-change-cb=$ctrl.calcPrice></currency-converter><span ng-bind=$ctrl.tmpl.convertion.to.currency></span> </span><span class=\"user-data animated fadeIn\" ng-show=$ctrl.tmpl.userData.active ng-bind=$ctrl.tmpl.userData.value></span></div><product-description ng-if=$ctrl.tmpl.description.publish description=$ctrl.item.description show-mode=$ctrl.tmpl.description.fields></product-description></section><div class=cut-description-toggler><a href ng-click=\"$event.stopPropagation();$ctrl.item.cuttedDescription = !$ctrl.item.cuttedDescription\">показать/скрыть описание</a></div><div class=date>Добавлена <span ng-bind=::$ctrl.today></span></div></div></div></div></section>");
$templateCache.put("app/components/productList/productList.html","<div class=selector ng-if=!$ctrl.exportProcess><div class=\"col-xs-12 margin-bottom-std\"><div class=action-wrapper><div class=multiple-images-toggle ng-if=$ctrl.site.multipleImages><button class=\"btn btn-default btn-select\" ng-click=$ctrl.toggleVariants() ng-if=!$ctrl.showMultipleImages>Показать расцветки</button> <button class=\"btn btn-default btn-select\" ng-click=$ctrl.toggleVariants() ng-if=$ctrl.showMultipleImages>Скрыть расцветки</button></div><div class=select-images-toggle><button class=\"btn btn-default btn-select\" ng-click=$ctrl.selectAll() ng-if=!$ctrl.selectedAll><i class=\"fa fa-check-square-o\" aria-hidden=true></i> Выделить все</button> <button class=\"btn btn-default btn-select\" ng-click=$ctrl.unselectAll() ng-if=$ctrl.selectedAll><i class=\"fa fa-square-o\" aria-hidden=true></i> Снять выделение</button></div><div class=\"btn-clear pull-right\"><button class=\"btn btn-danger center-block\" ng-click=$ctrl.clearProducts()>Очистить список</button></div><div class=\"btn-group pull-right\" uib-dropdown uib-tooltip=\"Выложить выделенные элементы\"><button class=\"btn btn-vz-green\" ng-click=$ctrl.productsSelected() ng-disabled=!$ctrl.selectedProducts.length><i class=\"fa fa-fw fa-vk\"></i> Выложить</button> <button type=button class=\"btn btn-vz-green dropdown-toggle\" ng-disabled=!$ctrl.selectedProducts.length uib-dropdown-toggle><span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu><li ng-if=\"$ctrl.lastSource.group && $ctrl.lastSource.album\"><a href ng-click=$ctrl.storeToLastSource()><i class=\"fa fa-fw fa-vk text-vz\"></i> <span>Выложить в группу <b ng-bind=$ctrl.lastSource.group.name></b>, альбом <b ng-bind=$ctrl.lastSource.album.name></b></span></a></li><li><a href ng-click=$ctrl.exportToFile()><i class=\"fa fa-fw fa-file-excel-o text-vz\"></i> <span>Экспорт в файл</span></a></li></ul></div></div></div><div class=\"col-xs-12 products-wrapper\"><product-item ng-repeat=\"item in $ctrl.products.data | filter:$ctrl.showMode() track by item.id\" class=col-xs-4 item=item tmpl=$ctrl.tmpl ccy=$ctrl.site.currency on-click=$ctrl.clickByItem></product-item></div></div>");
$templateCache.put("app/components/productSelector/productSelector.html","<div class=col-xs-4><process-template ng-if=$ctrl.products.site.props site=$ctrl.products.site tmpl=$ctrl.albumData.tmpl props=$ctrl.products.site.props></process-template></div><product-list class=\"col-xs-8 row\" products=$ctrl.products tmpl=$ctrl.albumData.tmpl site=$ctrl.products.site selected-products=$ctrl.selectedProducts></product-list>");
$templateCache.put("app/components/sourceSelector/sourceSelector.html","<div class=col-xs-5><group-list groups=$ctrl.groups on-click=$ctrl.clickByGroup></group-list></div><div class=col-xs-7><div ng-show=$ctrl.currentGroup.id><form ng-submit=$ctrl.findAlbums() class=\"search-wrapper margin-bottom-std\"><div class=\"search-btn-wrapper pull-right\"><button class=\"search-btn btn btn-default\" type=submit><i class=\"fa fa-fw fa-search\"></i></button></div><div class=search-input-wrapper><input ng-model=$ctrl.query class=\"search-input form-control\" placeholder=\"Введите название альбома...\"></div></form><album-list ng-if=$ctrl.albums class=clearfix id=group-album-list albums=$ctrl.albums on-click=$ctrl.clickByAlbum on-scroll=$ctrl.scrollAlbums scroll-container=#group-album-list on-create=$ctrl.refresh on-process=$ctrl.processProducts current-group=$ctrl.currentGroup></album-list></div></div>");
$templateCache.put("app/components/stateViewer/stateViewer.html","<div class=\"title-content clearfix\" ng-if=\"state !== 3\"><div class=\"col-xs-2 margin-top-dbl\"><a href ng-click=$ctrl.toFirstStep() ng-if=\"state === 2 || state === 4\"><i class=\"fa fa-fw fa-angle-double-left\"></i> <span>К шагу 1</span></a></div><div class=col-xs-8><h2 class=\"text-center text-vz margin-bottom-std\" ng-bind=$ctrl.titleContent></h2></div></div><section ng-if=\"state === 1\" class=clearfix><product-selector ng-if=$ctrl.products.size products=$ctrl.products selected-products=$ctrl.selected album-data=$ctrl.albumData></product-selector><div class=additional-info><h3 class=\"text-center text-vz\" ng-show=\"$ctrl.products.$resolved && !$ctrl.products.size\">Продукты еще не были получены</h3><spinner spinner-show=!$ctrl.products.$resolved spinner-size=80></spinner></div></section><section ng-if=\"state === 2\" class=clearfix><source-selector></source-selector></section><section ng-if=\"state === 3 && $ctrl.storeProcess.$resolved\" class=clearfix><final-message continue=$ctrl.afterProcess() clean-and-continue=$ctrl.cleanAndAfterProcess() store-to-another-source=$ctrl.storeToAnotherSource()></final-message></section><section ng-if=\"state === 4\" class=clearfix><file-export export-to-file=$ctrl.exportToFile></file-export></section><spinner spinner-show=\"$ctrl.storeProcess && !$ctrl.storeProcess.$resolved\" spinner-size=80></spinner>");}]);